import { useState, useEffect } from 'react'
import cn from 'clsx'
import OrganizationTypeahead from './OrganizationTypeahead'

const JoinOrgWidget = ({
    className,
    joinOrgName,
    setJoinOrgName,
    checkOrgExists,
    onJoinOrgClick,
}) => {
    
    const [orgExists, setOrgExists] = useState(false)
    
    useEffect(() => {
        
        const t = setTimeout(() => {
            setOrgExists(false)
            if (!joinOrgName.length) return
            
            checkOrgExists(joinOrgName)
                .then(exists => setOrgExists(exists))
        }, 500)
        
        return () => clearTimeout(t)
        
    }, [joinOrgName])
    
    return (
        
        <div className={cn('JoinOrgWidget', className)}>
            <div>
                <h3 className="text-xl">Join an Organization</h3>
                <div className="flex items-center content-center justify-between mt-2 form-group">
                    <OrganizationTypeahead className={cn({
                        'input-success': orgExists,
                    })} setOrgName={setJoinOrgName} orgName={joinOrgName} />
                    <button
                        className="ml-3 btn btn-primary"
                        disabled={!orgExists}
                        title={!orgExists ? 'Organization does not exist' : ''}
                        onClick={onJoinOrgClick}>
                        Join Organization
                    </button>
                </div>
            </div>
        </div>
        
    )
    
}

export default JoinOrgWidget
